import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { selectMasterCompanyId } from 'store/auth/selectors';

const useCompanyId = () => {
  const { companyId } = useParams();

  const masterCompanyId = useSelector(selectMasterCompanyId);

  if (companyId) {
    return companyId;
  }

  return masterCompanyId;
};

export default useCompanyId;
